import features from 'src/replicant/ruleset/features';
import type { Component, Entity2D } from '../../odie';

import { CountBlockOptionDef, DoorBlockProps } from '../defs/block';
import { DogHouseBlockView } from '../views/blocks/DogHouseBlockView';
import { DoorBlockView } from '../views/blocks/DoorBlockView';
import { user } from 'src/StateObserver';

// types
//-----------------------------------------------------------------------------
export type DoorBlockComponentOptions = {
  props: DoorBlockProps;
  option?: number;
};

/*
    door block component
*/
export class DoorBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockDoor';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: DoorBlockView | DogHouseBlockView;

  // properties
  //-------------------------------------------------------------------------
  // count
  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    this.view.count = value;
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: DoorBlockComponentOptions): void {
    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef;

    // create door block view
    this.view = features(user()).newFirst2ObstacleVisuals
      ? // Use the new dog house visual if new first 2 obstacle visuals is enabled
        new DogHouseBlockView(options.props)
      : new DoorBlockView(options.props);

    // set initial count
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    return this.view.count;
  }
}
